export enum MemberSearchType {
  all_members = 1,
  members_without_companions = 2,
  companions = 3,
}
